import DualListInputGroup from './DualListInputGroup';

export default DualListInputGroup;